import React from "react";
import { useForm, Link, Form } from "@inertiajs/react";
import { Button } from "@/components/ui/button";

interface FormData {
  email_address: string;
  password: string;
  password_confirmation: string;
}

interface Props {
  errors: Record<string, string[]>;
}

export default function New({ errors: serverErrors }: Props) {
  const { data, setData, post, processing, errors } = useForm<FormData>({
    email_address: "",
    password: "",
    password_confirmation: "",
  });

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Create your account
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Or{" "}
            <Link
              href="/session/new"
              className="font-medium text-blue-600 hover:text-blue-500"
            >
              sign in to your existing account
            </Link>
          </p>
        </div>

        <Form className="mt-8 space-y-6" action="/registrations" method="post">
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="user.email_address"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Email address"
              />
              {(errors.email_address || serverErrors.email_address) && (
                <p className="mt-1 text-sm text-red-600">
                  {errors.email_address || serverErrors.email_address?.[0]}
                </p>
              )}
            </div>

            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="user.password"
                type="password"
                autoComplete="new-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Password"
              />
              {(errors.password || serverErrors.password) && (
                <p className="mt-1 text-sm text-red-600">
                  {errors.password || serverErrors.password?.[0]}
                </p>
              )}
            </div>

            <div>
              <label htmlFor="password-confirmation" className="sr-only">
                Confirm Password
              </label>
              <input
                id="password-confirmation"
                name="user.password_confirmation"
                type="password"
                autoComplete="new-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Confirm password"
              />
              {(errors.password_confirmation ||
                serverErrors.password_confirmation) && (
                <p className="mt-1 text-sm text-red-600">
                  {errors.password_confirmation ||
                    serverErrors.password_confirmation?.[0]}
                </p>
              )}
            </div>
          </div>
          <div>
            <Button
              type="submit"
              disabled={processing}
              className="w-full"
            >
              {processing ? "Creating account..." : "Sign up"}
            </Button>
          </div>
          <div className="text-center text-sm">
            <span className="text-gray-600">
              By signing up, you agree to our{" "}
              <a href="#" className="text-blue-600 hover:text-blue-500">
                Terms of Service
              </a>{" "}
              and{" "}
              <a href="#" className="text-blue-600 hover:text-blue-500">
                Privacy Policy
              </a>
            </span>
          </div>
        </Form>
      </div>
    </div>
  );
}
